export default {
    control: {
      backgroundColor: '#fff',
      fontSize: 16,
      margin: "15px 0px 0px 0%",
      borderRadius:"5px",
      fontWeight: 'normal',
      border: '1px solid rgb(0,0,0,0.34)',
    },

    highlighter: {
      overflow: 'hidden',
      // backgroundColor:"green",
      // border: '2px inset green',
    },

    input: {
      margin: 0,
      width:"100%",
    },

    '&singleLine': {
      control: {
        display: 'inline-block',
        fontFamily:"'Open Sans', sans-serif !important",
        width: "100%",
      },

      highlighter: {
        padding: 1,
        // backgroundColor:"blue",
        border: '2px inset green',
      },

      input: {
        padding: 1,

        border: '2px inset',
      },
    },

    '&multiLine': {
      control: {
        // fontFamily: 'monospace',
        fontFamily:"'Open Sans', sans-serif !important",
        border: '1px solid rgb(0,0,0,0.34)',
      },

      highlighter: {
        padding: 9,
        // backgroundColor:"blue"
      },

      input: {
        padding: 9,
        minHeight: 63,
        outline: 0,
        border: 0,
      },
    },

    suggestions: {
      list: {
        backgroundColor: 'white',
        border: '1px solid rgba(0,0,0,0.15)',
        fontSize: 10,
      },

      item: {
        padding: '10px 15px',
        fontSize: 12,
        borderBottom: '1px solid rgba(0,0,0,0.15)',

        '&focused': {
          backgroundColor: '#cee4e5',
        },
      },
    },
  }
